import React, { useState } from 'react';
import { Client } from 'xrpl';

function App() {
  const TESTNET = 'wss://s.altnet.rippletest.net:51233';
  const MY_ADDRESS = 'rGvBzgxkNqR6LdJ8iRhJBebw6qekTXKshm';

  const [address, setAddress] = useState(MY_ADDRESS);
  const [balance, setBalance] = useState('17');
  const [clientSeed, setClientSeed] = useState('sEdSAzqkmiX KvRMxLnWojhwJGU6bTtr');
  const [clientAddress] = useState(MY_ADDRESS);
  const [botRunning, setBotRunning] = useState(false);
  const [botLog, setBotLog] = useState([]);

  const submitWithAutofill = async (tx, label = '') => {
    const client = new Client(TESTNET);
    await client.connect();
    const prepared = await client.autofill(tx);
    const result = await client.submitAndWait(prepared);
    await client.disconnect();
    setBotLog(prev => [...prev, `${label}: ${result.result.meta.TransactionResult}`]);
    return result;
  };

  const connectWallet = () => {
    setAddress(MY_ADDRESS);
    setBalance('17');
  };

  const placeBuyOrder = async () => {
    const tx = { TransactionType: 'OfferCreate', Account: MY_ADDRESS, TakerGets: '10000000', TakerPays: { currency: 'USD', issuer: 'rHb9CJAWyB4rj91VRWn96DkukG4bwdtyTh', value: '5' } };
    await submitWithAutofill(tx, 'Buy Order');
  };

  const placeSellOrder = async () => {
    const tx = { TransactionType: 'OfferCreate', Account: MY_ADDRESS, TakerGets: { currency: 'USD', issuer: 'rHb9CJAWyB4rj91VRWn96DkukG4bwdtyTh', value: '5' }, TakerPays: '10000000' };
    await submitWithAutofill(tx, 'Sell Order');
  };

  const handleDeposit = async () => await submitWithAutofill({ TransactionType: 'Payment', Account: MY_ADDRESS, Destination: MY_ADDRESS, Amount: '10000000' }, 'Deposit');
  const handleWithdraw = async () => await submitWithAutofill({ TransactionType: 'Payment', Account: MY_ADDRESS, Destination: MY_ADDRESS, Amount: '9500000' }, 'Withdraw');
  const handleClaim = async () => await submitWithAutofill({ TransactionType: 'Payment', Account: MY_ADDRESS, Destination: MY_ADDRESS, Amount: '1000000' }, 'Claim');
  const handleOnboard = async () => await submitWithAutofill({ TransactionType: 'TrustSet', Account: MY_ADDRESS, LimitAmount: { currency: 'XRP', issuer: 'rHb9CJAWyB4rj91VRWn96DkukG4bwdtyTh', value: '1000000000' } }, 'Onboard');

  const handleClientDeposit = async () => await submitWithAutofill({ TransactionType: 'Payment', Account: MY_ADDRESS, Destination: MY_ADDRESS, Amount: '10000000' }, 'Client Deposit');
  const handleClientWithdraw = async () => await submitWithAutofill({ TransactionType: 'Payment', Account: MY_ADDRESS, Destination: MY_ADDRESS, Amount: '9500000' }, 'Client Withdraw');

  const startQuantumAlphaBot = () => {
    if (botRunning) return;
    setBotRunning(true);
    setBotLog(['Quantum Alpha started']);
    const interval = setInterval(async () => {
      if (!botRunning) { clearInterval(interval); return; }
      await placeBuyOrder();
      await placeSellOrder();
      setBotLog(prev => [...prev, 'Quantum Alpha cycle']);
    }, 30000);
  };

  const startFreqtradeBot = () => {
    if (botRunning) return;
    setBotRunning(true);
    setBotLog(['Freqtrade started']);
    const interval = setInterval(async () => {
      if (!botRunning) { clearInterval(interval); return; }
      await placeBuyOrder();
      setBotLog(prev => [...prev, 'Freqtrade order']);
    }, 45000);
  };

  const startJesseBot = () => {
    if (botRunning) return;
    setBotRunning(true);
    setBotLog(['Jesse started']);
    const interval = setInterval(async () => {
      if (!botRunning) { clearInterval(interval); return; }
      await placeSellOrder();
      setBotLog(prev => [...prev, 'Jesse order']);
    }, 60000);
  };

  const stopBot = () => {
    setBotRunning(false);
    setBotLog(prev => [...prev, 'Stopped']);
  };

  const goldBtn = { margin: '5px', backgroundColor: 'gold', color: 'black', padding: '8px 16px' };

  return (
    <div style={{ backgroundColor: 'lightgreen', minHeight: '100vh', padding: '20px' }}>
      <h1>C Cubed Investments</h1>
      <h2>XRPL AI Pool</h2>
      <button onClick={connectWallet} style={goldBtn}>Connect Wallet</button>
      <p>Address: {address}</p>
      <p>Balance: {balance} XRP</p>
      <div>
        <button onClick={handleDeposit} style={goldBtn}>Deposit 10 XRP</button>
        <button onClick={handleWithdraw} style={goldBtn}>Withdraw (5% fee to dev)</button>
        <button onClick={handleClaim} style={goldBtn}>Claim Daily Profit</button>
        <button onClick={handleOnboard} style={goldBtn}>Onboard Client</button>
      </div>
      <p>New Client: {clientAddress} (seed: {clientSeed})</p>
      <hr />
      <h3>Client Trading Bot Access</h3>
      <input value={clientSeed} onChange={(e) => setClientSeed(e.target.value)} style={{ width: '400px' }} />
      <button onClick={handleClientDeposit} style={goldBtn}>Client Deposit 10 XRP to Trading Bot</button>
      <button onClick={handleClientWithdraw} style={goldBtn}>Client Request Withdraw from Trading Bot</button>
      <p>Client Address: {clientAddress}</p>

      <hr />
      <h3>Real Trading Bots</h3>
      <button onClick={placeBuyOrder} style={goldBtn}>Place Buy Order</button>
      <button onClick={placeSellOrder} style={goldBtn}>Place Sell Order</button>
      <button onClick={startQuantumAlphaBot} disabled={botRunning} style={goldBtn}>Start Quantum Alpha</button>
      <button onClick={startFreqtradeBot} disabled={botRunning} style={goldBtn}>Start Freqtrade</button>
      <button onClick={startJesseBot} disabled={botRunning} style={goldBtn}>Start Jesse</button>
      <button onClick={stopBot} disabled={!botRunning} style={goldBtn}>Stop All</button>
      <div style={{ marginTop: '10px', background: '#f0f0f0', padding: '10px', maxHeight: '200px', overflow: 'auto' }}>
        {botLog.map((log, i) => <div key={i}>{log}</div>)}
      </div>
    </div>
  );
}

export default App;
